import React from 'react';

import classNames from 'classnames';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';

import { CALENDAR_DISPLAY_NAME } from '../../constants';
import { useAccountListContext } from '../context';

const List: React.FC = () => {
  const { state } = useAccountListContext();
  const { accounts } = state;

  const navigate = useNavigate();
  const handleViewAccount = (accountId: string) => () => {
    navigate(`/app/accounts/${accountId}/overview`);
  };

  const RenderMovil: React.FC = () => {
    return (
      <div className="sm:hidden px-2 mt-6 overflow-auto">
        <ul className="mt-4" data-testid="accounts-list">
          {accounts.map((account) => (
            <li
              key={account.id}
              className="bg-white-0.0 flex flex-col justify-between rounded border border-white-2.0 mb-2 px-2 py-4"
              data-testid={`account-${account.id}`}
            >
              <div
                role="presentation"
                className="flex flex-col ml-4 truncate cursor-pointer"
                onClick={handleViewAccount(account.id)}
              >
                <p className="oversize my-auto font-bold text-primary-2.0">{account.name}</p>
              </div>
              <div className="flex flex-grow mt-4">
                <p className="ml-4 text-sm font-medium truncate">{account.email}</p>
              </div>
              <div className="flex flex-grow mt-2">
                <p className="ml-4 text-sm font-medium truncate">{account.office_phone}</p>
              </div>
              <div className="flex flex-grow mt-2">
                <p className="ml-4 text-sm font-medium truncate">
                  {CALENDAR_DISPLAY_NAME[account.calendar_type]}
                </p>
              </div>
              <div className="flex flex-grow mt-2">
                <p className="ml-4 text-sm font-medium truncate">
                  {account.company_industry?.name || 'Not set'}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const RenderStandard: React.FC = () => {
    return (
      <div className="sm:flex hidden mt-6 overflow-auto">
        <table className="min-w-full divide-y divide-white-2.0 flex-grow">
          <thead>
            <tr>
              <th className="data-cell-header rounded-tl">Account name</th>
              <th className="data-cell-header">Email</th>
              <th className="data-cell-header">Phone</th>
              <th className="data-cell-header">Calendar type</th>
              <th className="data-cell-header">Industry</th>
              <th className="data-cell-header rounded-tr">Last sync time</th>
            </tr>
          </thead>
          <tbody className="bg-white.0.0 divide-y divide-white-2.0" data-testid="accounts-list">
            {accounts.map((account, index) => (
              <tr
                key={account.id}
                className={classNames(
                  'cursor-pointer',
                  index % 2 === 0 ? 'bg-white-0.0' : 'bg-white-1.0'
                )}
                data-testid={`account-${account.id}`}
                onClick={handleViewAccount(account.id)}
              >
                <td className="data-cell">{account.name}</td>
                <td className="data-cell">{account.email}</td>
                <td className="data-cell">{account.office_phone}</td>
                <td className="data-cell">{CALENDAR_DISPLAY_NAME[account.calendar_type]}</td>
                <td className="data-cell">{account.company_industry?.name || 'Not set'}</td>
                <td className="data-cell">
                  {account.last_sync_time
                    ? DateTime.fromISO(account.last_sync_time).toFormat('ff')
                    : 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <RenderStandard />
      <RenderMovil />
    </>
  );
};

export default List;
